import { render, staticRenderFns } from "./charge-fee.vue?vue&type=template&id=2ebadae6&scoped=true&"
import script from "./charge-fee.vue?vue&type=script&lang=js&"
export * from "./charge-fee.vue?vue&type=script&lang=js&"
import style0 from "./charge-fee.vue?vue&type=style&index=0&id=2ebadae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebadae6",
  null
  
)

export default component.exports